module.exports = __webpack_public_path__ + "fonts/sourcesanspro-black-webfont.f377ee91.woff2";